const navbarLinks = [
    {
        id: 1,
        href: "",
        text: 'menu_home'
    },
    /*  {
         id: 2,
         href: "new-build",
         text: 'menu_builder'
     }, */
    {
        id: 3,
        href: "donate",
        text: 'menu_coffee'
    }/* ,
    {
        id: 4,
        href: "about-us",
        text: 'menu_about'
    } */
];

export default navbarLinks;